// const detectedLang = navigator.language.split("-")[0].toLowerCase();
// const lisioArrayLang = ["ar","de","da","es","en","fr","it","nl","pl","pt","ro","ru","tr","uk","zh"];
// const lisioNavigatorLang = window.location.href.includes("alpine-region.eu") ? "en" : lisioArrayLang.includes(detectedLang) ? detectedLang : "en";
interface LisioConfig {
  userSettings: {
    display: string;
    colorPrimary: string;
    colorEcolo: string;
    positionX: string;
    positionY: string;
    positionMobileX: string;
    positionMobileY: string;
    vPopin: string;
    top_bar_img: string; //VIP
    priorizedLanguages: string[];
    tabsToHide: string[];
    vocalSynthesisMode: 0 | 1;
    clientLogo?: string;
  };
}

const lisioConfig: LisioConfig = {
  // urls: {
  //   jsReadingMode: import.meta.env.VITE_LISIO_DOMAIN + "/solution/dist-site/readingMode.js",
  //   load: import.meta.env.VITE_LISIO_DOMAIN + "",
  //   // cursors: {
  //   //   arrows: {
  //   //     top: import.meta.env.VITE_LISIO_DOMAIN + "/solution/assets/top-arrow.png",
  //   //     bottom: import.meta.env.VITE_LISIO_DOMAIN + "/solution/assets/bottom-arrow.png",
  //   //     left: import.meta.env.VITE_LISIO_DOMAIN + "/solution/assets/left-arrow.png",
  //   //     right: import.meta.env.VITE_LISIO_DOMAIN + "/solution/assets/right-arrow.png",
  //   //   }
  //   // },
  //   PhP: "IM_GenerationMinisite.php",
  //   addStats: "https://www.mobiledition.com/addStats.php",
  // },
  userSettings: {
    display: "NULL",
    colorPrimary: "#15548a",
    colorEcolo: "#3e7040",
    positionX: "NULL",
    positionY: "NULL",
    positionMobileX: "NULL",
    positionMobileY: "NULL",
    vPopin: "NULL",
    top_bar_img: "",
    priorizedLanguages: [],
    tabsToHide: [],
    vocalSynthesisMode: 0,
    clientLogo: "",
  },
  // cookies: {
  //   version: "V2.4",
  //   defaultParamCookie: [
  //     0, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //   ],
  // },
};

window.postMessage("config finish", window.origin);

export { lisioConfig };

export type { LisioConfig };
